import { Thermostat } from "@mui/icons-material";
import { Box, Slider, Tooltip, Typography } from "@mui/material";

interface TemperatureControlProps {
  temperature: number;
  onTemperatureChange: (_event: Event, newValue: number | number[]) => void;
}

const TemperatureControl = ({ temperature, onTemperatureChange }: TemperatureControlProps) => {
  return (
    <Box sx={{ mt: 2 }}>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
        Model Settings
      </Typography>
      <Box sx={{ display: "flex", alignItems: "center" }}>
        <Tooltip title="Controls randomness: Lower values give more consistent, deterministic responses. Higher values make responses more creative and varied.">
          <Box sx={{ display: "flex", alignItems: "center", width: "100%" }}>
            <Thermostat fontSize="small" sx={{ color: "text.secondary", mr: 1 }} />
            <Typography variant="caption" sx={{ minWidth: 110, color: "text.secondary" }}>
              Temperature: {temperature.toFixed(2)}
            </Typography>
            <Slider
              value={temperature}
              onChange={onTemperatureChange}
              aria-label="Temperature"
              min={0}
              max={1}
              step={0.1}
              valueLabelDisplay="auto"
              sx={{ ml: 1, flex: 1 }}
            />
          </Box>
        </Tooltip>
      </Box>
    </Box>
  );
};

export default TemperatureControl;
